<template>
  <div class="content">
    <div>
      <div class="md-layout-item md-size-100 text-right">
        <md-button class="md-raised md-success mr-4" @click="amenitiesModal('new', {})">New Amenity</md-button>
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">Amenities</h4>
          </md-card-header>
          <md-card-content>
            <div class="tags_container">
              <md-chip
                  v-for="(amenity, index) in amenities"
                  :key="index"
                  class="skill-chip"
                  md-deletable
                  @md-delete="removeAmenity(amenity)"
              >
                <span @click="amenitiesModal('edit', amenity)">{{ amenity.name }}</span>
              </md-chip>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>

    <!-- add/edit dialog-->
    <md-dialog :md-active.sync="showDialog" class="custom-dialog md-size-100">
      <md-dialog-title>{{modalText.title}} Amenity</md-dialog-title>

      <div class="md-layout-item md-small-size-100 md-size-100 px-4">
        <md-field class="mb-1" :class="{ 'md-invalid': modalErrors && modalErrors.name }">
          <label>Amenity Name</label>
          <md-input
              v-model="modalData.name"
              type="text"
              required
              md-placeholder="Amenity name"
          ></md-input>
          <span class="md-error" v-if="modalErrors && modalErrors.name">
            {{ modalErrors.name[0] }}
          </span>
        </md-field>
      </div>
      <md-dialog-actions class="m-3">
        <md-button class="md-secondary" @click="showDialog = false">Close</md-button>
        <md-button class="md-success" @click="onConfirm()">{{modalText.btnText}} Amenity</md-button>
      </md-dialog-actions>
    </md-dialog>
    <!-- add/edit dialog-->

    <!-- delete dialog-->
    <md-dialog :md-active.sync="showDelDialog" class="custom-dialog md-size-100">
      <md-dialog-title>Delete Amenity</md-dialog-title>

      <div class="md-layout-item md-small-size-100 md-size-100 px-4">
        <h4>Are you sure you want to delete this amenity?</h4>
        <br>
        <p>This action cannot be undone and the amenity details will be permanently removed.</p>
      </div>
      <md-dialog-actions class="m-3">
        <md-button class="md-secondary" @click="showDelDialog = false">Close</md-button>
        <md-button class="md-success" @click="onConfirmDel()">Delete Amenity</md-button>
      </md-dialog-actions>
    </md-dialog>
    <!-- delete dialog-->

  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "AdminAmenities",
  data() {
    return {
      showDialog: false,
      showDelDialog: false,
      modalText: {
        title: 'New',
        btnText: 'Add'
      },
      modalData: {
        id: '',
        name: '',
        mode: ''
      },
      modalErrors: {},
      amenities: []
    }
  },
  created() {
    this.getAllAmenities()
  },
  methods: {
    ...mapActions(["getAdminAmenities", "createEditAmenity", "deleteAdminAmenity"]),
    getAllAmenities() {
      this.getAdminAmenities()
      .then(res => {
        this.amenities = res.data.data
      })
    },
    amenitiesModal(mode, item) {
      this.showDialog = true
      this.modalErrors = {}
      if(mode == 'new') {
        this.modalData.id = ''
        this.modalData.name = ''
        this.modalData.mode = 'new'
        this.modalText.title = 'New'
        this.modalText.btnText = 'Create'
      } else {
        this.modalText.title = 'Edit'
        this.modalText.btnText = 'Update'
        this.modalData.mode = 'edit'
        this.modalData.id = item.id
        this.modalData.name = item.name
      }
    },
    onConfirm() {
      this.modalErrors = {};

      const newName = (this.modalData.name || '').trim();

      if (!newName) {
        this.modalErrors = { name: ['Amenity name is required'] };
        return;
      }

      const exists = this.amenities.some(amenity => {
        if (this.modalData.mode === 'edit' && amenity.id === this.modalData.id) {
          return false;
        }
        return amenity.name.trim().toLowerCase() === newName.toLowerCase();
      });

      if (exists) {
        this.modalErrors = { name: ['Amenity with this name already exists'] };
        return;
      }

      this.modalData.name = newName;

      this.createEditAmenity(this.modalData)
          .then(res => {
            if (res.status == 422) {
              this.modalErrors = res.response.data.errors;
            } else {
              this.showDialog = false;
              this.getAllAmenities();
            }
          });
    },
    removeAmenity(amenity) {
      this.modalData.id = amenity.id
      this.modalData.name = amenity.name
      this.showDelDialog = true
    },
    onConfirmDel() {
      this.deleteAdminAmenity(this.modalData.id)
      .then(res => {
        if(res.status == 200 || res.status == 201) {
          this.showDelDialog = false
          this.getAllAmenities()
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.tags_container {
  padding: 20px;
}

.skill-chip {
  background: #000;
  color: #fff;
  border-radius: 20px;
  padding: 4px 35px 4px 14px;
  line-height: 34px;
  font-size: 16px;
  margin: 14px;
  display: inline-table;
  cursor: pointer;
  & span {
    padding: 10px;
  }
  &:hover {
    background: #333;
  }
}

.mr-4 {
  margin-right: 16px;
}

.text-right {
  text-align: right;
}
</style>
